import React from 'react'
import styles from './AppLogo.module.scss'

interface AppLogoProps {
  letter?: string
  className?: never
}

export const AppLogo: React.FC<AppLogoProps> = ({ letter = 'C' }) => (
  <div className={styles.logo}>{letter}</div>
)
